"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_PAGE_BUTTON_TYPE = exports.FORM_PAGE_FOOTER_TYPE = exports.FORM_PAGE_HEADER_TYPE = exports.FORM_PAGE_TYPE = void 0;
exports.FORM_PAGE_TYPE = {
    INPUT: 'INPUT',
    CONFIRM: 'CONFIRM',
    COMPLETE: 'COMPLETE',
    PRIVATE: 'PRIVATE',
    AUTHENTICATION: 'AUTHENTICATION',
    RECEPTION_COMPLETE: 'RECEPTION_COMPLETE',
    RECEPTION_AUTHENTICATION_ERROR: 'RECEPTION_AUTHENTICATION_ERROR',
};
exports.FORM_PAGE_HEADER_TYPE = {
    rawHtml: 'rawHtml',
};
exports.FORM_PAGE_FOOTER_TYPE = {
    rawHtml: 'rawHtml',
};
exports.FORM_PAGE_BUTTON_TYPE = {
    next: 'next',
    previous: 'previous',
};
